import { OwnershipState } from './state';
import { ownershipInitialState } from './initial-state';
import { OwnershipActions } from './action-creators';
import * as actions from './actions';

export const ownershipReducer = (
  state: OwnershipState = ownershipInitialState,
  action: OwnershipActions
): OwnershipState => {
  switch (action.type) {
    case actions.CREATE_OWNERSHIP_SUCCESS: {
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.ownership.assetId]: {
            ...state.assets[action.ownership.assetId],
            [action.ownership.id]: action.ownership,
          },
        },
        updateStatus: 'saved',
      };
    }

    case actions.UPDATE_OWNERSHIP_ORDER: {
      const newState = {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
          },
        },
      };

      Object.keys(newState.assets[action.assetId]).forEach((ownerId) => {
        if (action.newOrder.includes(ownerId)) {
          newState.assets[action.assetId][ownerId] = {
            ...newState.assets[action.assetId][ownerId],
            order: action.newOrder.indexOf(ownerId),
          };
        }
      });

      return newState;
    }

    case actions.GET_OWNERSHIPS_SUCCESS: {
      const newState: OwnershipState = {
        ...state,
        assets: {
          ...state.assets,
        },
      };

      action.ownerships.forEach((ownership) => {
        if (ownership.requestedSplit === 0) {
          delete ownership.requestedSplit;
        }
        if (!(ownership.assetId in newState.assets)) {
          newState.assets[ownership.assetId] = {};
        }
        newState.assets[ownership.assetId][ownership.id] = {
          ...ownership,
          split: ownership.split || 0,
        };
      });

      return newState;
    }

    case actions.REMOVE_OWNERSHIP: {
      const newState: OwnershipState = {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {},
        },
      };

      Object.values(state.assets[action.assetId]).forEach((ownership) => {
        if (ownership.id === action.ownershipId) {
          return;
        }

        newState.assets[ownership.assetId][ownership.id] = {
          ...ownership,
        };
      });

      return newState;
    }

    case actions.UPDATE_OWNERSHIP_FIELD: {
      delete state.assets[action.assetId][action.ownershipId].requestedSplit;
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
            [action.ownershipId]: {
              ...state.assets[action.assetId][action.ownershipId],
              [action.field]: action.value,
            },
          },
        },
        updateStatus: 'modified',
      };
    }
    case actions.UPDATE_REQUEST_OWNERSHIP_FIELD_SUCCESS: {
      return {
        ...state,
        updateStatus: 'saved',
      };
    }

    case actions.UPDATE_OWNERSHIP_SUCCESS: {
      return {
        ...state,
        updateStatus: 'saved',
      };
    }

    case actions.GET_OWNERSHIPS_BY_USER_ID_SUCCESS: {
      return {
        ...state,
        userOwnerships: action.userOwnerships,
      };
    }

    case actions.GET_OWNERSHIPS_ERROR: {
      return {
        ...state,
        userOwnerships: undefined,
      };
    }

    case actions.REASSIGN_SPLITS_SUCCESS: {
      const newState: OwnershipState = {
        ...state,
        assets: {
          ...state.assets,
        },
        updateStatus: 'saved',
        unsavedAssetId: action.isUnsaved ? action.newSplits.assetId : undefined,
      };
      if (action.newSplits.newOwnerShips.length > 0) {
        for (let newOwnership of action.newSplits.newOwnerShips) {
          newState.assets[action.newSplits.assetId] = {
            ...newState.assets[action.newSplits.assetId],
            [newOwnership.id]: newOwnership,
          };
        }
      }
      let ownerShipIdArr = action.newSplits.splitUpdate.map(
        (split) => split.ownershipId
      );
      Object.keys(newState.assets[action.newSplits.assetId]).forEach((key) => {
        let ownershipData = Object.values(
          newState.assets[action.newSplits.assetId]
        ).find((ownership) => ownership.id === key);
        if (
          !ownerShipIdArr.includes(key) &&
          (!ownershipData ||
            (ownershipData &&
              ownershipData.ownershipType === action.newSplits.ownershipType))
        ) {
          delete newState.assets[action.newSplits.assetId][key];
        }
      });

      action.newSplits.splitUpdate.forEach((splitData) => {
        if (
          newState.assets[action.newSplits.assetId][splitData.ownershipId] &&
          newState.assets[action.newSplits.assetId][splitData.ownershipId]
            .requestedSplit
        ) {
          delete newState.assets[action.newSplits.assetId][
            splitData.ownershipId
          ]['requestedSplit'];
        }
        newState.assets[action.newSplits.assetId] = {
          ...newState.assets[action.newSplits.assetId],
          [splitData.ownershipId]: {
            ...newState.assets[action.newSplits.assetId][splitData.ownershipId],
            split: splitData.split,
            order: action.newSplits.splitUpdate.indexOf(splitData),
          },
        };
      });
      return newState;
    }

    case actions.CLEAR_OWNERSHIP_STATE: {
      return ownershipInitialState;
    }

    default: {
      return { ...state };
    }
  }
};
